import { render } from "./KindEvent.vue?vue&type=template&id=dac29154"
import script from "./KindEvent.vue?vue&type=script&lang=js"
export * from "./KindEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__